<mydocma-tree class="structure-tree"
  [options]="treeOptions"
  [nodeData]="structures"
  [selectedNodeId]="selected?.Id?.toString()"
  (nodeSelected) ="this.onClick($event)">

  <ng-template mydocmaTreeNodeContent let-tree let-node="node">
    <ng-container class="custom-node-container">
      <div class="node-container-wrapper">
        <span class="node-text" [innerHTML]="structureFilterService.getInnerHtml(node.data) && (treeService.filterService.filters?.length ?? 0) > 0 ? (structureFilterService.getInnerHtml(node.data) | translate) : (node.text | translate)">
        </span>
        <div *ngIf="hasAddresses && (((structureAddressesService.structureAddresses$ | async)?.get(+node.id)?.length ?? 0) > 0) && appContainerService.isMobileView && selected?.Id?.toString() === node?.id?.toString()" class="address-info" [class.structure-selected]="selected?.Id?.toString() === node?.id?.toString()"
             (mousedown)="$event.stopPropagation()"
             (click)="$event.stopPropagation(); onAddressInfoClick(node, $any($event.currentTarget))">
          <mydocma-custom-mat-icon class="icon-address-info" [iconName]="'_info'"></mydocma-custom-mat-icon>
        </div>

        <div *ngIf="hasAddresses && (((structureAddressesService.structureAddresses$ | async)?.get(+node.id)?.length ?? 0) > 0) && !appContainerService.isMobileView && deviceService.isTablet() && selected?.Id?.toString() === node?.id?.toString()" class="address-info" [class.structure-selected]="selected?.Id?.toString() === node?.id?.toString()"
             [matMenuTriggerFor]="menu"
             #menuTrigger="matMenuTrigger"
             (mousedown)="$event.stopPropagation()"
             (click)="$event.stopPropagation(); onAddressInfoClick(node, $any($event.currentTarget))">
          <mydocma-custom-mat-icon class="icon-address-info" [iconName]="'_info'"></mydocma-custom-mat-icon>
          <mat-menu #menu="matMenu" class="address-info-menu" (closed)="onAddressMenuClosed()">
            <div mat-menu-item class="address-info-menu-item" [class.address-info-expanded]="isExpanded" (click)="$event.stopPropagation()">
              <mydocma-mm-structure-addresses #addressesComponent [addresses]="currentAddresses" [structure]="currentStructure" (isExpanded)="isExpanded = $event" (closeMenu)="menuTrigger.closeMenu()">
              </mydocma-mm-structure-addresses>
            </div>
          </mat-menu>
        </div>

        <div *ngIf="hasAddresses && (((structureAddressesService.structureAddresses$ | async)?.get(+node.id)?.length ?? 0) > 0) && !appContainerService.isMobileView && !deviceService.isTablet()" class="address-info" [class.structure-selected]="selected?.Id?.toString() === node?.id?.toString()"
             [matMenuTriggerFor]="menu"
             #menuTrigger="matMenuTrigger"
             (mousedown)="$event.stopPropagation()"
             (click)="$event.stopPropagation(); onAddressInfoClick(node, $any($event.currentTarget))">
          <mydocma-custom-mat-icon class="icon-address-info" [iconName]="'_info'"></mydocma-custom-mat-icon>
          <mat-menu #menu="matMenu" class="address-info-menu" (closed)="onAddressMenuClosed()">
            <div mat-menu-item class="address-info-menu-item" [class.address-info-expanded]="isExpanded" (click)="$event.stopPropagation()">
              <mydocma-mm-structure-addresses #addressesComponent
                                              [addresses]="currentAddresses"
                                              [structure]="currentStructure"
                                              (isExpanded)="isExpanded = $event"
                                              (closeMenu)="menuTrigger?.closeMenu()">
              </mydocma-mm-structure-addresses>
            </div>
          </mat-menu>
        </div>

      </div>
    </ng-container>
  </ng-template>
</mydocma-tree>
